"use strict";

var _localforage = _interopRequireDefault(require("localforage"));

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.default = void 0;

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    default: a
  };
}

function storage(a) {
  var b = _localforage.default.createInstance({
    name: a
  });

  return {
    db: b,
    getItem: b.getItem,
    setItem: b.setItem,
    removeItem: b.removeItem
  };
}

var _default = storage;
exports.default = _default;